export const statusOptions = ['PENDING', 'APPROVED', 'VOIDED', 'REFUNDED', 'DECLINED', 'EXPIRED', 'CANCELED', 'ADVICE', 'REVERSAL'];
export const acquirerOptions = ['PAYWAY', 'GLOBAL_PROCESSING', 'FISERV', 'COELSA', 'COELSA_BIND'];
export const brandOptions = ['VISA', 'MASTERCARD', 'MAESTRO', 'NARANJA'];
export const cardTypeOptions = ['CREDIT', 'DEBIT', 'PREPAID', 'DEBIT_PREPAID', 'CHARGE', 'FLEET', 'UNKNOWN'];
export const paymentMethodOptions = [
  { value: 'CARD', label: 'Tarjeta' },
  { value: 'QR_PCT', label: 'QR PCT' },
  { value: 'QR_CARD', label: 'QR Tarjeta' },
  { value: 'PIX', label: 'PIX' },
  { value: 'CARD_CASHBACK', label: 'Tarjeta + Cash Back' }
];
export const entryModeOptions = ['CONTACT', 'CONTACTLESS', 'MAG_STRIPE', 'MANUAL', 'QR'];
export const originOptions = ['POS', 'INTEGRATED', 'API'];
export const contextOptions = ['PURCHASE', 'VOID', 'REFUND', 'REVERSAL', 'VOID_REFUND', 'WITHDRAWAL', 'AUTHORIZATION', 'BALANCE_INQUIRY', 'RECONCILIATION', 'ADMIN', 'NETWORK_MANAGEMENT'];
export const processTypeOptions = ['PAYFAC', 'GATEWAY', 'PAYFAC_WHITELABEL', 'GATEWAY_WHITELABEL', 'DIRECT'];

export const isoStatusOptions = [
  { value: 'PENDING', label: 'PENDING' },
  { value: 'APPROVED', label: 'APPROVED' },
  { value: 'DECLINED', label: 'DECLINED' },
  { value: 'UNKNOWN_NEW_1', label: 'UNKNOWN NEW' },
  { value: 'REVERSED', label: 'REVERSED' },
  { value: 'SETTLED', label: 'SETTLED' },
  { value: 'ERROR', label: 'ERROR' },
  { value: 'ADVICE', label: 'ADVICE' },
  { value: 'RECONCILIATION', label: 'RECONCILIATION' },
  { value: 'UNKNOWN_NEW_2', label: 'UNKNOWN NEW' }
];

export const isoEntryModeOptions = [
  { value: 'CONTACT', label: 'Contact' },
  { value: 'CONTACTLESS', label: 'Contactless' },
  { value: 'MAG_STRIPE', label: 'Banda' },
  { value: 'MANUAL', label: 'Manual' }
];

export const isoProcessingOptions = [
  { value: 'PURCHASE_REQUEST', label: 'Solicitud de Compra' },
  { value: 'VOID_REQUEST', label: 'Solicitud de Anulacion' },
  { value: 'REFUND_REQUEST', label: 'Solicitud Devolucion' },
  { value: 'BATCH_CLOSE_REQUEST', label: 'Solicitud de Cierre de Lote' },
  { value: 'VOID_REFUND_REQUEST', label: 'Solicitud de Anulacion de Devolucion' },
  { value: 'PURCHASE_CASHBACK_REQUEST', label: 'Solicitud de Compra + Cash Back' },
  { value: 'PURCHASE_MAESTRO_SAVINGS_ARS', label: 'Compra Maestro Caja de Ahorro en Pesos' },
  { value: 'PURCHASE_CASHBACK_MAESTRO_SAVINGS_ARS', label: 'Compra Maestro + Cash Back Caja de Ahorro en Pesos' },
  { value: 'VOID_MAESTRO_SAVINGS_ARS', label: 'Anulacion Maestro Caja de Ahorro en Pesos' },
  { value: 'REFUND_MAESTRO_SAVINGS_ARS', label: 'Devolucion Maestro Caja de Ahorro en Pesos' },
  { value: 'VOID_REFUND_MAESTRO_SAVINGS_ARS', label: 'Anulacion de Devolucion Maestro Caja de Ahorro en Pesos' },
  { value: 'VOID_CASHBACK_MAESTRO_SAVINGS_ARS', label: 'Anulacion Maestro + Cash Back Caja de Ahorro en Pesos' },
  { value: 'PURCHASE_MAESTRO_CHECKING_ARS', label: 'Compra Maestro Cuenta Corriente en Pesos' },
  { value: 'PURCHASE_CASHBACK_MAESTRO_CHECKING_ARS', label: 'Compra Maestro + Cash Back Cuenta Corriente en Pesos' },
  { value: 'VOID_MAESTRO_CHECKING_ARS', label: 'Anulacion Maestro Cuenta Corriente en Pesos' },
  { value: 'REFUND_MAESTRO_CHECKING_ARS', label: 'Devolucion Maestro Cuenta Corriente en Pesos' },
  { value: 'VOID_REFUND_MAESTRO_CHECKING_ARS', label: 'Anulacion de Devolucion Maestro Cuenta Corriente en Pesos' },
  { value: 'VOID_CASHBACK_MAESTRO_CHECKING_ARS', label: 'Anulacion Maestro + Cash Back Cuenta Corriente en Pesos' },
  { value: 'PURCHASE_MAESTRO_SAVINGS_USD', label: 'Compra Maestro Caja de Ahorro en USD' },
  { value: 'PURCHASE_CASHBACK_MAESTRO_SAVINGS_USD', label: 'Compra Maestro + Cash Back Caja de Ahorro en USD' },
  { value: 'VOID_MAESTRO_SAVINGS_USD', label: 'Anulacion Maestro Caja de Ahorro en USD' },
  { value: 'REFUND_MAESTRO_SAVINGS_USD', label: 'Devolucion Maestro Caja de Ahorro en USD' },
  { value: 'VOID_REFUND_MAESTRO_SAVINGS_USD', label: 'Anulacion de Devolucion Maestro Caja de Ahorro en USD' },
  { value: 'VOID_CASHBACK_MAESTRO_SAVINGS_USD', label: 'Anulacion Maestro + Cash Back Caja de Ahorro en USD' },
  { value: 'PURCHASE_MAESTRO_CHECKING_USD', label: 'Compra Maestro Cuenta Corriente en USD' },
  { value: 'PURCHASE_CASHBACK_MAESTRO_CHECKING_USD', label: 'Compra Maestro + Cash Back Cuenta Corriente en USD' },
  { value: 'VOID_MAESTRO_CHECKING_USD', label: 'Anulacion Maestro Cuenta Corriente en USD' },
  { value: 'REFUND_MAESTRO_CHECKING_USD', label: 'Devolucion Maestro Cuenta Corriente en USD' },
  { value: 'VOID_REFUND_MAESTRO_CHECKING_USD', label: 'Anulacion de Devolucion Maestro Cuenta Corriente en USD' },
  { value: 'VOID_CASHBACK_MAESTRO_CHECKING_USD', label: 'Anulacion Maestro + Cash Back Cuenta Corriente en USD' }
];
